// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

export async function getFileButtonPermissions(options?: { [key: string]: any }) {
  return request<API.RESPONSE>('/api/fileCompany/getFileButtonPermissions', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取知识库文件内容操作权限 POST /appAdmin/getDatasetButtonPermissions */
export async function getDatasetButtonPermissions(thirdpartyAppId: string, options?: { [key: string]: any }) {
  return request<API.RESPONSE>('/api/appAdmin/getDatasetButtonPermissions', {
    method: 'POST',
    data: { thirdpartyAppId },
    ...(options || {}),
  });
}
